import { render, staticRenderFns } from "./VircosDelivery.vue?vue&type=template&id=4b74185c&scoped=true&"
import script from "./VircosDelivery.vue?vue&type=script&lang=js&"
export * from "./VircosDelivery.vue?vue&type=script&lang=js&"
import style0 from "./VircosDelivery.vue?vue&type=style&index=0&id=4b74185c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74185c",
  null
  
)

export default component.exports